import { apolloClient } from "@/plugins/vue-apollo.js";

const createFacility = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/facility/create_facility.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/facility/facility_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allFacility = store.readQuery(query);
        allFacility.getFacilities.facilities.unshift(data.createFacility); //push to top
        store.writeQuery({
          ...query,
            data: allFacility,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createFacility };
